import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { FloatingDelayGroup } from "./auth-service-tools430.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { TooltipGroupProvider } from "./auth-service-tools431.js";
const defaultProps = {
  openDelay: 0,
  closeDelay: 0
};

function TooltipGroup(props) {
  const {
    openDelay,
    closeDelay,
    children
  } = useProps("TooltipGroup", defaultProps, props);
  return /* @__PURE__ */jsxRuntimeExports.jsx(TooltipGroupProvider, {
    value: true,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(FloatingDelayGroup, {
      delay: {
        open: openDelay,
        close: closeDelay
      },
      children
    })
  });
}

TooltipGroup.displayName = "@mantine/core/TooltipGroup";

TooltipGroup.extend = c => c;

export { TooltipGroup };